import { render, staticRenderFns } from "./ImpersonationBanner.vue?vue&type=template&id=6742b860&scoped=true&"
import script from "./ImpersonationBanner.vue?vue&type=script&lang=js&"
export * from "./ImpersonationBanner.vue?vue&type=script&lang=js&"
import style0 from "./ImpersonationBanner.vue?vue&type=style&index=0&id=6742b860&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6742b860",
  null
  
)

export default component.exports